(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seed-brand-switch"] && !Shopify.designMode) return;
  try {
    const brandSwitchBinding = 'seedBrandSwitchBound';
  const brandSwitchRequestParameter = '__seed_brand_switch';
  const loadedUrl = new URL(window.location.href);

  if (loadedUrl.searchParams.has(brandSwitchRequestParameter)) {
    loadedUrl.searchParams.delete(brandSwitchRequestParameter);
    window.history.replaceState(window.history.state, '', loadedUrl.href);
  }

  if (!document.documentElement.dataset[brandSwitchBinding]) {
    document.documentElement.dataset[brandSwitchBinding] = 'true';

    const validBrands = new Set(['geoseed', 'twilley']);

    const persistBrand = async (brand) => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _seed_brand_preview: brand } }),
      });
      if (!response.ok) throw new Error(`Cart update failed (status ${response.status}).`);
      const cart = await response.json();
      if (cart.attributes?._seed_brand_preview !== brand) {
        throw new Error('Cart update did not persist the selected storefront brand.');
      }
    };

    // Direct entry chooses a brand in Liquid; persist it before leaving for a shared page.
    const entrySwitcher = document.querySelector('[data-seed-brand-entry="true"]');
    const entryBrand = entrySwitcher?.dataset.seedActiveBrand;
    const needsEntrySync = validBrands.has(entryBrand) && entrySwitcher.dataset.seedPersistedBrand !== entryBrand;
    const entrySync = needsEntrySync
      ? persistBrand(entryBrand).then(() => true).catch((error) => {
          console.error('Unable to retain storefront brand.', error);
          return false;
        })
      : Promise.resolve(true);

    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const option = target?.closest('[data-seed-brand-option]');
      const switcher = option?.closest('[data-seed-brand-switch]');
      const brand = option?.dataset.seedBrandOption;

      if (switcher && validBrands.has(brand)) {
        event.preventDefault();
        if (switcher.dataset.seedBrandSwitchBusy === 'true') return;
        switcher.dataset.seedBrandSwitchBusy = 'true';
        switcher.setAttribute('aria-busy', 'true');
        switcher.querySelector('[role="status"]').hidden = true;
        const brandTarget = new URL(option.href, window.location.origin);

        const previewTheme = loadedUrl.searchParams.get('preview_theme_id');
        if (previewTheme) brandTarget.searchParams.set('preview_theme_id', previewTheme);

        if (brandTarget.pathname === window.location.pathname && !brandTarget.searchParams.has('view')) {
          brandTarget.search = window.location.search;
          brandTarget.hash = window.location.hash;
        }

        const navigateToBrand = () => {
          brandTarget.searchParams.set(brandSwitchRequestParameter, brand);
          window.location.assign(brandTarget.href);
        };

        try {
          // A deliberate switch must win over an in-flight landing-page update.
          await entrySync;
          await persistBrand(brand);
          navigateToBrand();
        } catch (error) {
          console.error('Unable to switch storefront brand.', error);
          delete switcher.dataset.seedBrandSwitchBusy;
          switcher.removeAttribute('aria-busy');
          switcher.querySelector('[role="status"]').hidden = false;
        }

        return;
      }

      const link = target?.closest('a[href]');
      if (needsEntrySync && link && !event.defaultPrevented && event.button === 0 &&
          !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
          (!link.target || link.target === '_self') && !link.hasAttribute('download')) {
        const destination = new URL(link.href, window.location.href);
        if (destination.origin === window.location.origin &&
            (destination.pathname !== window.location.pathname || destination.search !== window.location.search)) {
          event.preventDefault();
          const persisted = await entrySync;
          if (persisted) destination.searchParams.set(brandSwitchRequestParameter, entryBrand);
          window.location.assign(destination.href);
          return;
        }
      }

      document.querySelectorAll('[data-seed-brand-switch][open]').forEach((openSwitcher) => {
        if (target && openSwitcher.contains(target)) return;
        openSwitcher.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const openSwitcher = document.querySelector('[data-seed-brand-switch][open]');
      if (!openSwitcher) return;

      openSwitcher.open = false;
      openSwitcher.querySelector('summary')?.focus();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
